<template>
  <div class="cardPopup">
    <Popup :close-on-click-overlay="false" class="popup_box" v-model="isShow">
      <div class="container">
        <slot></slot>
      </div>

      <div class="popup_close">
        <img @click="closePopup" src="@/assets/home/guanbi2@2x.png" alt="" />
      </div>
    </Popup>
  </div>
</template>

<script>
import { Popup } from "vant";
export default {
  name: "cardPopup",
  components: { Popup },
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      isShow: this.show,
    };
  },
  watch: {
    show(newVal) {
      this.isShow = newVal;
    },
  },
  methods: {
    closePopup() {
      this.isShow = false;
      this.$emit("closePopup");
    },
  },
};
</script>

<style lang="less" scoped>
.cardPopup {
  /deep/ .van-overlay {
    background: rgba(101, 101, 101, 0.2);
    backdrop-filter: blur(3px);
  }
}
.popup_box {
  box-sizing: border-box;
  background: none;
  width: 325px;
  border-radius: 18px;
  .container {
  }
  .popup_close {
    position: absolute;
    top: 20px;
    right: 20px;
    img {
      width: 14px;
      height: 14px;
    }
  }
}
</style>
